<!--
 * @Description: 学生多条查找带回
 * @Author: PF
 * @Date: 2023-02-03 15:00:22
 * @LastEditors: PF
 * @LastEditTime: 2025-05-06 16:10:46
-->
<template>
  <div class="cha-zhao-duo-tiao">
    <el-dialog class="w1200 h800" :model-value="openDuoTiao" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <span class="header-title">学生</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDuoTiao', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-row style="height: 100%;">
        <el-col :span="11" style="height: 100%">
          <el-container>
            <el-header style="padding:0">
              <el-form class="search" :model="dataGrid.parms">
                <el-form-item class="wp48 mb10">
                  <el-input v-model="dataGrid.parms.keyword" placeholder="学号/姓名" clearable filterable  />
                </el-form-item>
                <el-button class="w250 mb10" type="success" @click="initLeftList()"><span class="el-icon--left iconfont icon-sousuo"></span>查询</el-button>
                <el-button class="w250 mb10" type="success" @click="openGaoJiChaXunJiaoShi=true"><span class="el-icon--left iconfont icon-sousuo" :style="dataGrid.parms.gaoJiQuery?'color:#ff0':''"></span>高级查询</el-button>
              </el-form>
            </el-header>
            <el-main style="padding:0">
              <el-table :data="dataGrid.data" border v-loading="dataGrid.loading" height="100%" @selection-change="leftSelectionChange" @row-dblclick="leftRowDblclick">
                <el-table-column type="selection" align="center" width="55" />
                <el-table-column label="学号" prop="xh" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
                <el-table-column label="姓名" prop="xm" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
                  <template #default="scope">
                    <el-link type="primary" @click="seeClick(scope.row)">{{scope.row.xm}}</el-link>
                  </template>
                </el-table-column>
                <el-table-column label="性别" prop="xb" align="center" show-overflow-tooltip />
                <el-table-column width="55" align="center" show-overflow-tooltip>
                  <template #default="scope">
                    <el-button link type="primary" @click.stop="leftRowDblclick(scope.row)">
                      <span class="iconfont icon-youjiantou"></span>
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-main>
          </el-container>
        </el-col>
        <el-col :span="2" style="height: 100%">
          <div class="but_group">
            <span class="iconfont icon-shuangjiantouzuo" @click="toLeftClick"></span>
            <span class="iconfont icon-shuangjiantouyou" @click="toRightClick"></span>
          </div>
        </el-col>
        <el-col :span="11" style="height: 100%">
          <el-table :data="rightTableData" border v-loading="dataGrid.loading" height="100%" @selection-change="rightSelectionChange" @row-dblclick="rightRowDblclick">
            <el-table-column type="selection" align="center" width="55" />
            <el-table-column width="55" fixed align="center" show-overflow-tooltip>
              <template #default="scope">
                <el-button link type="primary" :disabled="!scope.row.id" @click.stop="rightRowDblclick(scope.row)">
                  <span class="iconfont icon-zuojiantou"></span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="学号" prop="xh" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="姓名" prop="xm" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
              <template #default="scope">
                <el-link type="primary" @click="seeClick(scope.row)">{{scope.row.xm}}</el-link>
              </template>
            </el-table-column>
            <el-table-column label="性别" prop="xb" align="center" show-overflow-tooltip />
          </el-table>
        </el-col>
      </el-row>

      <template #footer>
        <div class="dialog-footer">
          <el-row style="width: 100%">
            <el-col :span="11">
              <span style="font-size: 14px;">共 {{ dataGrid.data.length }} 条</span>
            </el-col>
            <el-col :span="2">
            </el-col>
            <el-col :span="11" style="display: flex;align-items: center;justify-content: space-between;">
              <span style="font-size: 14px;">共 {{ rightTableData.length }} 条</span>
              <div class="footer_but">
                <el-button type="primary" @click="savestudent()">选择</el-button>
                <el-button type="info" @click="closeWindow('openDuoTiao', emits, false)">关闭</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </template>
    </el-dialog>
  </div>
  <gaojichaxunxuesheng  v-if="openGaoJiChaXunXueSheng" v-model:openGaoJi="openGaoJiChaXunXueSheng" :row="dataGrid.parms.gaoJiQuery" @ReturnData="xueShengGaoJiRet" />
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { closeWindow, loadList, actionPost } from '@/api/common.js'
import gaojichaxunxuesheng from '@/components/gaojichaxun/xuesheng.vue'

const props = defineProps({
  openDuoTiao: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDuoTiao', 'ReturnData'])

// 学生高级查询
const openGaoJiChaXunXueSheng = ref(false)
const xueShengGaoJiRet = (data) => {
  dataGrid.value.parms = {}
  if (data.length !== 0) {
    dataGrid.value.parms.gaoJiQuery = data
  }
  initLeftList()
}

const row = ref({ ids: [] })

const rightTableData = ref([]) // 右侧列表
const leftMultipleSelection = ref([]) // 左侧多选
const rightMultipleSelection = ref([]) // 右侧多选
const savestudent = () => {
  emits('ReturnData', rightTableData.value)
  closeWindow('openDuoTiao', emits, false)
}

// 双击左侧列表
const leftRowDblclick = (row) => {
  leftMultipleSelection.value.push(row)
  toRightClick()
}
// 双击右侧列表
const rightRowDblclick = (row) => {
  rightMultipleSelection.value.push(row)
  toLeftClick()
}
// 左箭头
const toLeftClick = () => {
  if (rightMultipleSelection.value.length) {
    rightMultipleSelection.value.forEach((element) => {
      dataGrid.value.data.unshift(element)
      rightTableData.value.forEach((e, index) => {
        if (e.id === element.id) {
          rightTableData.value.splice(index, 1)
        }
      })
    })
    if (rightTableData.value) {
      row.value.ids = rightTableData.value.map((item) => item.id)
    }
    initLeftList()
    initRightList()
    rightMultipleSelection.value = []
  }
}
// 右箭头
const toRightClick = () => {
  if (leftMultipleSelection.value.length) {
    leftMultipleSelection.value.forEach((element) => {
      rightTableData.value.push(element)
      dataGrid.value.data.forEach((e, index) => {
        if (e.id === element.id) {
          dataGrid.value.data.splice(index, 1)
        }
      })
    })
    if (rightTableData.value) {
      row.value.ids = rightTableData.value.map((item) => item.id)
    }
    initLeftList()
    initRightList()
    leftMultipleSelection.value = []
  }
}
// 左侧复选框
const leftSelectionChange = (val) => {
  leftMultipleSelection.value = []
  if (val.length) {
    val.forEach((element) => {
      leftMultipleSelection.value.push(element)
    })
  }
}
// 右侧复选框
const rightSelectionChange = (val) => {
  rightMultipleSelection.value = []
  if (val.length) {
    val.forEach((element) => {
      rightMultipleSelection.value.push(element)
    })
  }
}

const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'xh', order: 'ascending' }, // ['ascending', 'descending']
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    initLeftList()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const initLeftList = async () => {
  dataGrid.value.parms.notInIDs = row.value.ids
  if (dataGrid.value.orderBy) {
    dataGrid.value.parms.order = dataGrid.value.orderBy.prop // 排序条件
    dataGrid.value.parms.sort = dataGrid.value.orderBy.order === 'ascending' ? 'asc' : 'desc' // 排序方式
  }
  dataGrid.value.parms.menuId = sessionStorage.getItem('menuId')
  // 分割线----------------------------------------------------
  const o = { url: '/api/v2/pdp/xuesheng/banjixuesheng', data: dataGrid.value.parms }
  dataGrid.value.loading = true // 开始加载
  actionPost(o).then((res) => {
    dataGrid.value.loading = false // 结束加载
    if (res.code === 200) {
      dataGrid.value.data = res.data || [] // 返回列表
      dataGrid.value.multipleSelection = []
    } else {
      warningPrompt(res.message)
    }
  })
}

const initRightList = async () => {
  rightTableData.value = []
  dataGrid.value.loading = true
  const o = {
    url: '/api/v2/pdp/xuesheng/list',
    data: {
      order: 'xh',
      sort: 'asc',
      inIDs: row.value.ids,
      menuId: sessionStorage.getItem('menuId')
    }
  }
  actionPost(o).then((res) => {
    dataGrid.value.loading = false
    rightTableData.value = res.data // 返回列表
  })
}
watch(
  () => props.openDuoTiao,
  () => {
    if (props.openDuoTiao) {
      row.value = props.row || []
      dataGrid.value.parms.bjid = props.row.bjid
      initLeftList()
      initRightList()
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="less" scoped>
:deep(.filter-item) {
  width: 150px;
}
.search {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .el-button {
    margin: 0;
  }
}
:deep(.el-radio__label) {
  display: none;
}
:deep(.el-tabs__content) {
  display: none;
}
.el-tabs {
  height: 55px;
}
:deep(.but_group) {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column-reverse;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  .iconfont {
    font-size: 1.5rem;
    cursor: pointer;
  }
}
.e-row {
  height: 100%;
}
</style>
